import React, { useState } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
} from "reactstrap";
import classnames from "classnames";
import { Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import icon from "../../images/icon/ser-01.svg";
import picon from "../../images/icon/pricing-icon01.svg";
import picon2 from "../../images/icon/pricing-icon02.svg";
import picon3 from "../../images/icon/pricing-icon03.svg";
import check from "../../images/icon/check-icon.svg";
import cross from "../../images/icon/cross-icon.svg";
// Importando GIFs animados
import shieldGif from "../../images/icon/shield.gif";
import securityGif from "../../images/icon/cloud-security.gif";
import backupGif from "../../images/icon/database.gif";
import supportGif from "../../images/icon/support.gif";
import fastGif from "../../images/icon/24-hour-service.gif";
import savingsGif from "../../images/icon/savings.gif";
import warningGif from "../../images/icon/warning.gif";
import startup from "../../images/icon/startup.gif";

const DataCenterPricingSection = () => {
  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section id="planos" className="pricing pt-130 pb-130">
      <div className="container">
        <div className="sec-title--two text-center mb-60">
          <Fade
            direction="down"
            triggerOnce={"false"}
            duration={1000}
            delay={9}
          >
            <div>
              <div
                className="sub-title wow fadeInDown"
                data-wow-duration="600ms"
              >
                <img src={icon} alt="" />
                Cloud VPS
              </div>
            </div>
          </Fade>
          <Fade
            direction="down"
            triggerOnce={"false"}
            duration={1200}
            delay={9}
          >
            <div>
              <h2
                className="title wow fadeInDown"
                data-wow-delay="150ms"
                data-wow-duration="600ms"
              >
                Cloud VPS com Performance Superior
              </h2>
              <p style={{ marginTop: "20px", color: "#666", fontSize: "18px" }}>
                Servidores virtuais privados com recursos dedicados e
                performance até 3x superior.
              </p>
            </div>
          </Fade>
        </div>

        <div className="xb-pricing-nav-wrap text-center mb-110">
          <Nav
            tabs
            className="xb-pricing-nav ul_li_center nav nav-tabs"
            id="myTab"
            role="tablist"
          >
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                onClick={() => toggle("1")}
              >
                Anual
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => toggle("2")}
              >
                Mensal
              </NavLink>
            </NavItem>
          </Nav>
        </div>

        <div className="pg-pricing_content">
          <TabContent activeTab={activeTab} id="myTabContent">
            {/* Planos Anuais */}
            <TabPane tabId="1">
              <Row className="mt-none-30">
                {/* Plano Starter */}
                <Col lg="4" className="mt-30">
                  <div className="pg-pricing-item pos-rel">
                    <div className="xb-item--inner o-hidden pos-rel">
                      <div className="xb-item--holder ul_li">
                        <div className="xb-item--icon">
                          <img src={picon} alt="" />
                        </div>
                        <div className="xb-item--right">
                          <h3 className="xb-item--title">Cloud VPS Starter</h3>
                        </div>
                      </div>
                      <div className="xb-item--price">
                        <h2 className="xb-item--number">R$ 148,90</h2>
                        <span className="xb-item--time">Por mês</span>
                      </div>
                      <div className="xb-item--line"></div>
                      <h4 className="xb-item--feature">Recursos Inclusos</h4>
                      <ul className="xb-item--list list-unstyled">
                        <li>
                          <img src={check} alt="" /> 4 vCPU
                        </li>
                        <li>
                          <img src={check} alt="" /> 8GB RAM
                        </li>
                        <li>
                          <img src={check} alt="" /> 128GB SSD+
                        </li>
                      </ul>
                      <div className="pg-det-btn">
                        <Link
                          onClick={ClickHandler}
                          to="/contact"
                          className="cp-btn"
                          style={{
                            background: "#0E55DC",
                            borderColor: "#0E55DC",
                          }}
                        >
                          Contratar Agora
                        </Link>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Plano Business - Mais Popular */}
                <Col lg="4" className="mt-30">
                  <div className="pg-pricing-item pos-rel">
                    <div className="xb-item--inner o-hidden pos-rel">
                      <div className="xb-item--holder ul_li">
                        <div className="xb-item--icon">
                          <img src={picon2} alt="" />
                        </div>
                        <div className="xb-item--right">
                          <h3 className="xb-item--title">Cloud VPS Business</h3>
                        </div>
                      </div>
                      <div className="xb-item--price">
                        <h2 className="xb-item--number">R$ 295,20</h2>
                        <span className="xb-item--time">Por mês</span>
                      </div>
                      <div className="xb-item--line"></div>
                      <h4 className="xb-item--feature">Recursos Inclusos</h4>
                      <ul className="xb-item--list list-unstyled">
                        <li>
                          <img src={check} alt="" /> 8 vCPU
                        </li>
                        <li>
                          <img src={check} alt="" /> 16GB RAM
                        </li>
                        <li>
                          <img src={check} alt="" /> 256GB SSD+
                        </li>
                      </ul>
                      <div className="pg-det-btn">
                        <Link
                          onClick={ClickHandler}
                          to="/contact"
                          className="cp-btn"
                          style={{
                            background: "#0E55DC",
                            borderColor: "#0E55DC",
                          }}
                        >
                          Contratar Agora
                        </Link>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Plano Enterprise */}
                <Col lg="4" className="mt-30">
                  <div className="pg-pricing-item pos-rel">
                    <div className="xb-item--inner o-hidden pos-rel">
                      <div className="xb-item--holder ul_li">
                        <div className="xb-item--icon">
                          <img src={picon3} alt="" />
                        </div>
                        <div className="xb-item--right">
                          <h3 className="xb-item--title">
                            Cloud VPS Enterprise
                          </h3>
                        </div>
                      </div>
                      <div className="xb-item--price">
                        <h2 className="xb-item--number">R$ 520,40</h2>
                        <span className="xb-item--time">Por mês</span>
                      </div>
                      <div className="xb-item--line"></div>
                      <h4 className="xb-item--feature">Recursos Inclusos</h4>
                      <ul className="xb-item--list list-unstyled">
                        <li>
                          <img src={check} alt="" /> 12 vCPU
                        </li>
                        <li>
                          <img src={check} alt="" /> 32GB RAM
                        </li>
                        <li>
                          <img src={check} alt="" /> 512GB SSD+
                        </li>
                      </ul>
                      <div className="pg-det-btn">
                        <Link
                          onClick={ClickHandler}
                          to="/contact"
                          className="cp-btn"
                          style={{
                            background: "#0E55DC",
                            borderColor: "#0E55DC",
                          }}
                        >
                          Contratar Agora
                        </Link>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </TabPane>

            {/* Planos Mensais */}
            <TabPane tabId="2">
              <Row className="mt-none-30">
                {/* Plano Starter Mensal */}
                <Col lg="4" className="mt-30">
                  <div className="pg-pricing-item pos-rel">
                    <div className="xb-item--inner o-hidden pos-rel">
                      <div className="xb-item--holder ul_li">
                        <div className="xb-item--icon">
                          <img src={picon} alt="" />
                        </div>
                        <div className="xb-item--right">
                          <h3 className="xb-item--title">Cloud VPS Starter</h3>
                        </div>
                      </div>
                      <div className="xb-item--price">
                        <h2 className="xb-item--number">R$ 194,00</h2>
                        <span className="xb-item--time">Por mês</span>
                      </div>
                      <div className="xb-item--line"></div>
                      <h4 className="xb-item--feature">Recursos Inclusos</h4>
                      <ul className="xb-item--list list-unstyled">
                        <li>
                          <img src={check} alt="" /> 4 vCPU
                        </li>
                        <li>
                          <img src={check} alt="" /> 8GB RAM
                        </li>
                        <li>
                          <img src={check} alt="" /> 128GB SSD+
                        </li>
                      </ul>
                      <div className="pg-det-btn">
                        <Link
                          onClick={ClickHandler}
                          to="/contact"
                          className="cp-btn"
                        >
                          Contratar Agora
                        </Link>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Plano Business Mensal */}
                <Col lg="4" className="mt-30">
                  <div className="pg-pricing-item pos-rel">
                    <div className="xb-item--inner o-hidden pos-rel">
                      <div className="xb-item--holder ul_li">
                        <div className="xb-item--icon">
                          <img src={picon2} alt="" />
                        </div>
                        <div className="xb-item--right">
                          <h3 className="xb-item--title">Cloud VPS Business</h3>
                        </div>
                      </div>
                      <div className="xb-item--price">
                        <h2 className="xb-item--number">R$ 358,00</h2>
                        <span className="xb-item--time">Por mês</span>
                      </div>
                      <div className="xb-item--line"></div>
                      <h4 className="xb-item--feature">Recursos Inclusos</h4>
                      <ul className="xb-item--list list-unstyled">
                        <li>
                          <img src={check} alt="" /> 8 vCPU
                        </li>
                        <li>
                          <img src={check} alt="" /> 16GB RAM
                        </li>
                        <li>
                          <img src={check} alt="" /> 256GB SSD+
                        </li>
                      </ul>
                      <div className="pg-det-btn">
                        <Link
                          onClick={ClickHandler}
                          to="/contact"
                          className="cp-btn"
                        >
                          Contratar Agora
                        </Link>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* Plano Enterprise Mensal */}
                <Col lg="4" className="mt-30">
                  <div className="pg-pricing-item pos-rel">
                    <div className="xb-item--inner o-hidden pos-rel">
                      <div className="xb-item--holder ul_li">
                        <div className="xb-item--icon">
                          <img src={picon3} alt="" />
                        </div>
                        <div className="xb-item--right">
                          <h3 className="xb-item--title">
                            Cloud VPS Enterprise
                          </h3>
                        </div>
                      </div>
                      <div className="xb-item--price">
                        <h2 className="xb-item--number">R$ 606,00</h2>
                        <span className="xb-item--time">Por mês</span>
                      </div>
                      <div className="xb-item--line"></div>
                      <h4 className="xb-item--feature">Recursos Inclusos</h4>
                      <ul className="xb-item--list list-unstyled">
                        <li>
                          <img src={check} alt="" /> 12 vCPU
                        </li>
                        <li>
                          <img src={check} alt="" /> 32GB RAM
                        </li>
                        <li>
                          <img src={check} alt="" /> 512GB SSD+
                        </li>
                      </ul>
                      <div className="pg-det-btn">
                        <Link
                          onClick={ClickHandler}
                          to="/contact"
                          className="cp-btn"
                          style={{
                            background: "#0E55DC",
                            borderColor: "#0E55DC",
                          }}
                        >
                          Contratar Agora
                        </Link>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </div>
        {/* Seção de Benefícios */}
        <div className="benefits-section mt-100">
          <div className="text-center mb-50">
            <h3 style={{ color: "#333", marginBottom: "20px" }}>
              Por que escolher nosso Cloud VPS?
            </h3>
          </div>
          <Row>
            <Col lg="3" md="6" className="mb-30">
              <div className="benefit-item text-center">
                <div
                  className="benefit-icon"
                  style={{
                    fontSize: "48px",
                    color: "#FFC107",
                    marginBottom: "20px",
                  }}
                ></div>
                <img
                  src={startup}
                  alt="SLA"
                  style={{ width: "50px", height: "50px" }}
                />
                <h4 style={{ color: "#333", marginBottom: "15px" }}>
                  Deploy Instantâneo
                </h4>
                <p>
                  Seu Cloud VPS pronto para uso em poucos minutos após a
                  contratação.
                </p>
              </div>
            </Col>
            <Col lg="3" md="6" className="mb-30">
              <div className="benefit-item text-center">
                <div
                  className="benefit-icon"
                  style={{
                    fontSize: "48px",
                    color: "#FFC107",
                    marginBottom: "20px",
                  }}
                >
                  <img
                    src={shieldGif}
                    alt="SLA"
                    style={{ width: "50px", height: "50px" }}
                  />
                </div>
                <h4 style={{ color: "#333", marginBottom: "15px" }}>
                  99.9% Uptime
                </h4>
                <p>
                  Infraestrutura redundante e monitoramento 24/7 garantem máxima
                  disponibilidade.
                </p>
              </div>
            </Col>
            <Col lg="3" md="6" className="mb-30">
              <div className="benefit-item text-center">
                <div
                  className="benefit-icon"
                  style={{
                    fontSize: "48px",
                    color: "#FFC107",
                    marginBottom: "20px",
                  }}
                >
                  <img
                    src={savingsGif}
                    alt="SLA"
                    style={{ width: "50px", height: "50px" }}
                  />
                </div>
                <h4 style={{ color: "#333", marginBottom: "15px" }}>
                  Performance 3x Superior
                </h4>
                <p>
                  Cloud VPS com performance até 3x superior aos concorrentes
                  internacionais.
                </p>
              </div>
            </Col>
            <Col lg="3" md="6" className="mb-30">
              <div className="benefit-item text-center">
                <div
                  className="benefit-icon"
                  style={{
                    fontSize: "48px",
                    color: "#FFC107",
                    marginBottom: "20px",
                  }}
                >
                  <img
                    src={supportGif}
                    alt="SLA"
                    style={{ width: "50px", height: "50px" }}
                  />
                </div>
                <h4 style={{ color: "#333", marginBottom: "15px" }}>
                  Suporte Expert
                </h4>
                <p>
                  Equipe técnica especializada disponível 24/7 para suporte
                  completo.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </section>
  );
};
export default DataCenterPricingSection;
